import { LayoutNavbarComponent } from '../layout-navbar/layout-navbar.component';
import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { LayoutService } from '../layout.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { LayoutFooterComponent } from '../layout-footer/layout-footer.component';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from '../../../share/shared.module';

@Component({
  selector: 'app-layout-maintenance',
  templateUrl: './layout-maintenance.component.html',
  styles: [':host { display: block; }', ':host ::ng-deep .layout-loading .sidenav-link { transition: none !important; }'],
  imports: [SharedModule, LayoutFooterComponent, LayoutNavbarComponent, RouterOutlet],
  providers: [NgbDropdownConfig] // add NgbDropdownConfig to the component providers
})
export class LayoutMaintenanceComponent implements AfterViewInit, OnDestroy {
  // Prevent "blink" effect
  public initialized = false;

  constructor(private layoutService: LayoutService, config: NgbDropdownConfig) {
    config.placement = 'top-left';
    config.autoClose = 'outside';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialized = true;

      this.layoutService.init();
      this.layoutService.update();
      this.layoutService.setAutoUpdate(true);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.layoutService.destroy();
    });
  }

  closeSidenav() {
    setTimeout(() => {
      this.layoutService.setCollapsed(true);
    });
  }
}
